export { default } from './OOSModalCardProduct';
